export const content = "No, we do not offer court-ordered therapy or psychiatric evaluations. You may consider reaching out for other therapeutic support as you navigate these challenges.\n";
